import React, { useEffect, useState } from "react";
import { CardElement, useStripe, useElements } from "@stripe/react-stripe-js";
import { Card, CardBody, Col, Row, Dropdown, DropdownToggle, DropdownMenu, DropdownItem, Table, Badge, Button } from 'reactstrap';
import "../../assets/css/--component-billing-pricing.css"
import CheckoutIcon from "../../assets/images/checkout-icon.png"
import GlobalLoader from "../../components/GlobalLoader";
import { decompressFromEncodedURIComponent } from "lz-string";
import { Link, useNavigate, useSearchParams } from "react-router-dom";
import { paymentProcess } from "../../helper/backend-methods";
import { showToast } from "../../components/Toast";
import { useAppContext } from "../../context/AppContext";

const CheckoutPage = () => {
    const { updateTrialInfo, setIsActiveSubscription } = useAppContext();
    const [searchParams] = useSearchParams();
    const navigate = useNavigate();
    const encoded = searchParams.get("data");
    const [details, setDetails] = useState({ userEmail: localStorage.getItem("userName"), cardName: "", country: "", address1: "", address2: "", suburb: "", postalCode: "", city: "", state: "" });
    const [subscriptionData, setSubscriptionData] = useState(null);
    const [loading, setLoading] = useState(true)
    const stripe = useStripe();
    const elements = useElements();
    const countries = [
        { code: "AF", name: "Afghanistan" },
        { code: "AX", name: "Åland Islands" },
        { code: "AL", name: "Albania" },
        { code: "DZ", name: "Algeria" },
        { code: "AS", name: "American Samoa" },
        { code: "AD", name: "Andorra" },
        { code: "AO", name: "Angola" },
        { code: "AI", name: "Anguilla" },
        { code: "AQ", name: "Antarctica" },
        { code: "AG", name: "Antigua and Barbuda" },
        { code: "AR", name: "Argentina" },
        { code: "AM", name: "Armenia" },
        { code: "AW", name: "Aruba" },
        { code: "AU", name: "Australia" },
        { code: "AT", name: "Austria" },
        { code: "AZ", name: "Azerbaijan" },
        { code: "BS", name: "Bahamas" },
        { code: "BH", name: "Bahrain" },
        { code: "BD", name: "Bangladesh" },
        { code: "BB", name: "Barbados" },
        { code: "BY", name: "Belarus" },
        { code: "BE", name: "Belgium" },
        { code: "BZ", name: "Belize" },
        { code: "BJ", name: "Benin" },
        { code: "BM", name: "Bermuda" },
        { code: "BT", name: "Bhutan" },
        { code: "BO", name: "Bolivia" },
        { code: "BQ", name: "Bonaire, Sint Eustatius and Saba" },
        { code: "BA", name: "Bosnia and Herzegovina" },
        { code: "BW", name: "Botswana" },
        { code: "BV", name: "Bouvet Island" },
        { code: "BR", name: "Brazil" },
        { code: "IO", name: "British Indian Ocean Territory" },
        { code: "BN", name: "Brunei Darussalam" },
        { code: "BG", name: "Bulgaria" },
        { code: "BF", name: "Burkina Faso" },
        { code: "BI", name: "Burundi" },
        { code: "CV", name: "Cabo Verde" },
        { code: "KH", name: "Cambodia" },
        { code: "CM", name: "Cameroon" },
        { code: "CA", name: "Canada" },
        { code: "KY", name: "Cayman Islands" },
        { code: "CF", name: "Central African Republic" },
        { code: "TD", name: "Chad" },
        { code: "CL", name: "Chile" },
        { code: "CN", name: "China" },
        { code: "CX", name: "Christmas Island" },
        { code: "CC", name: "Cocos (Keeling) Islands" },
        { code: "CO", name: "Colombia" },
        { code: "KM", name: "Comoros" },
        { code: "CG", name: "Congo" },
        { code: "CD", name: "Congo, Democratic Republic of the" },
        { code: "CK", name: "Cook Islands" },
        { code: "CR", name: "Costa Rica" },
        { code: "CI", name: "Côte d'Ivoire" },
        { code: "HR", name: "Croatia" },
        { code: "CU", name: "Cuba" },
        { code: "CW", name: "Curaçao" },
        { code: "CY", name: "Cyprus" },
        { code: "CZ", name: "Czechia" },
        { code: "DK", name: "Denmark" },
        { code: "DJ", name: "Djibouti" },
        { code: "DM", name: "Dominica" },
        { code: "DO", name: "Dominican Republic" },
        { code: "EC", name: "Ecuador" },
        { code: "EG", name: "Egypt" },
        { code: "SV", name: "El Salvador" },
        { code: "GQ", name: "Equatorial Guinea" },
        { code: "ER", name: "Eritrea" },
        { code: "EE", name: "Estonia" },
        { code: "SZ", name: "Eswatini" },
        { code: "ET", name: "Ethiopia" },
        { code: "FK", name: "Falkland Islands (Malvinas)" },
        { code: "FO", name: "Faroe Islands" },
        { code: "FJ", name: "Fiji" },
        { code: "FI", name: "Finland" },
        { code: "FR", name: "France" },
        { code: "GF", name: "French Guiana" },
        { code: "PF", name: "French Polynesia" },
        { code: "TF", name: "French Southern Territories" },
        { code: "GA", name: "Gabon" },
        { code: "GM", name: "Gambia" },
        { code: "GE", name: "Georgia" },
        { code: "DE", name: "Germany" },
        { code: "GH", name: "Ghana" },
        { code: "GI", name: "Gibraltar" },
        { code: "GR", name: "Greece" },
        { code: "GL", name: "Greenland" },
        { code: "GD", name: "Grenada" },
        { code: "GP", name: "Guadeloupe" },
        { code: "GU", name: "Guam" },
        { code: "GT", name: "Guatemala" },
        { code: "GG", name: "Guernsey" },
        { code: "GN", name: "Guinea" },
        { code: "GW", name: "Guinea-Bissau" },
        { code: "GY", name: "Guyana" },
        { code: "HT", name: "Haiti" },
        { code: "HM", name: "Heard Island and McDonald Islands" },
        { code: "VA", name: "Holy See" },
        { code: "HN", name: "Honduras" },
        { code: "HK", name: "Hong Kong" },
        { code: "HU", name: "Hungary" },
        { code: "IS", name: "Iceland" },
        { code: "IN", name: "India" },
        { code: "ID", name: "Indonesia" },
        { code: "IR", name: "Iran, Islamic Republic of" },
        { code: "IQ", name: "Iraq" },
        { code: "IE", name: "Ireland" },
        { code: "IM", name: "Isle of Man" },
        { code: "IL", name: "Israel" },
        { code: "IT", name: "Italy" },
        { code: "JM", name: "Jamaica" },
        { code: "JP", name: "Japan" },
        { code: "JE", name: "Jersey" },
        { code: "JO", name: "Jordan" },
        { code: "KZ", name: "Kazakhstan" },
        { code: "KE", name: "Kenya" },
        { code: "KI", name: "Kiribati" },
        { code: "KP", name: "Korea, Democratic People's Republic of" },
        { code: "KR", name: "Korea, Republic of" },
        { code: "KW", name: "Kuwait" },
        { code: "KG", name: "Kyrgyzstan" },
        { code: "LA", name: "Lao People's Democratic Republic" },
        { code: "LV", name: "Latvia" },
        { code: "LB", name: "Lebanon" },
        { code: "LS", name: "Lesotho" },
        { code: "LR", name: "Liberia" },
        { code: "LY", name: "Libya" },
        { code: "LI", name: "Liechtenstein" },
        { code: "LT", name: "Lithuania" },
        { code: "LU", name: "Luxembourg" },
        { code: "MO", name: "Macao" },
        { code: "MG", name: "Madagascar" },
        { code: "MW", name: "Malawi" },
        { code: "MY", name: "Malaysia" },
        { code: "MV", name: "Maldives" },
        { code: "ML", name: "Mali" },
        { code: "MT", name: "Malta" },
        { code: "MH", name: "Marshall Islands" },
        { code: "MQ", name: "Martinique" },
        { code: "MR", name: "Mauritania" },
        { code: "MU", name: "Mauritius" },
        { code: "YT", name: "Mayotte" },
        { code: "MX", name: "Mexico" },
        { code: "FM", name: "Micronesia, Federated States of" },
        { code: "MD", name: "Moldova, Republic of" },
        { code: "MC", name: "Monaco" },
        { code: "MN", name: "Mongolia" },
        { code: "ME", name: "Montenegro" },
        { code: "MS", name: "Montserrat" },
        { code: "MA", name: "Morocco" },
        { code: "MZ", name: "Mozambique" },
        { code: "MM", name: "Myanmar" },
        { code: "NA", name: "Namibia" },
        { code: "NR", name: "Nauru" },
        { code: "NP", name: "Nepal" },
        { code: "NL", name: "Netherlands" },
        { code: "NC", name: "New Caledonia" },
        { code: "NZ", name: "New Zealand" },
        { code: "NI", name: "Nicaragua" },
        { code: "NE", name: "Niger" },
        { code: "NG", name: "Nigeria" },
        { code: "NU", name: "Niue" },
        { code: "NF", name: "Norfolk Island" },
        { code: "MK", name: "North Macedonia" },
        { code: "MP", name: "Northern Mariana Islands" },
        { code: "NO", name: "Norway" },
        { code: "OM", name: "Oman" },
        { code: "PK", name: "Pakistan" },
        { code: "PW", name: "Palau" },
        { code: "PS", name: "Palestine, State of" },
        { code: "PA", name: "Panama" },
        { code: "PG", name: "Papua New Guinea" },
        { code: "PY", name: "Paraguay" },
        { code: "PE", name: "Peru" },
        { code: "PH", name: "Philippines" },
        { code: "PN", name: "Pitcairn" },
        { code: "PL", name: "Poland" },
        { code: "PT", name: "Portugal" },
        { code: "PR", name: "Puerto Rico" },
        { code: "QA", name: "Qatar" },
        { code: "RE", name: "Réunion" },
        { code: "RO", name: "Romania" },
        { code: "RU", name: "Russian Federation" },
        { code: "RW", name: "Rwanda" },
        { code: "BL", name: "Saint Barthélemy" },
        { code: "SH", name: "Saint Helena, Ascension and Tristan da Cunha" },
        { code: "KN", name: "Saint Kitts and Nevis" },
        { code: "LC", name: "Saint Lucia" },
        { code: "MF", name: "Saint Martin (French part)" },
        { code: "PM", name: "Saint Pierre and Miquelon" },
        { code: "VC", name: "Saint Vincent and the Grenadines" },
        { code: "WS", name: "Samoa" },
        { code: "SM", name: "San Marino" },
        { code: "ST", name: "Sao Tome and Principe" },
        { code: "SA", name: "Saudi Arabia" },
        { code: "SN", name: "Senegal" },
        { code: "RS", name: "Serbia" },
        { code: "SC", name: "Seychelles" },
        { code: "SL", name: "Sierra Leone" },
        { code: "SG", name: "Singapore" },
        { code: "SX", name: "Sint Maarten (Dutch part)" },
        { code: "SK", name: "Slovakia" },
        { code: "SI", name: "Slovenia" },
        { code: "SB", name: "Solomon Islands" },
        { code: "SO", name: "Somalia" },
        { code: "ZA", name: "South Africa" },
        { code: "GS", name: "South Georgia and the South Sandwich Islands" },
        { code: "SS", name: "South Sudan" },
        { code: "ES", name: "Spain" },
        { code: "LK", name: "Sri Lanka" },
        { code: "SD", name: "Sudan" },
        { code: "SR", name: "Suriname" },
        { code: "SJ", name: "Svalbard and Jan Mayen" },
        { code: "SE", name: "Sweden" },
        { code: "CH", name: "Switzerland" },
        { code: "SY", name: "Syrian Arab Republic" },
        { code: "TW", name: "Taiwan, Province of China" },
        { code: "TJ", name: "Tajikistan" },
        { code: "TZ", name: "Tanzania, United Republic of" },
        { code: "TH", name: "Thailand" },
        { code: "TL", name: "Timor-Leste" },
        { code: "TG", name: "Togo" },
        { code: "TK", name: "Tokelau" },
        { code: "TO", name: "Tonga" },
        { code: "TT", name: "Trinidad and Tobago" },
        { code: "TN", name: "Tunisia" },
        { code: "TR", name: "Turkey" },
        { code: "TM", name: "Turkmenistan" },
        { code: "TC", name: "Turks and Caicos Islands" },
        { code: "TV", name: "Tuvalu" },
        { code: "UG", name: "Uganda" },
        { code: "UA", name: "Ukraine" },
        { code: "AE", name: "United Arab Emirates" },
        { code: "GB", name: "United Kingdom" },
        { code: "US", name: "United States" },
        { code: "UM", name: "United States Minor Outlying Islands" },
        { code: "UY", name: "Uruguay" },
        { code: "UZ", name: "Uzbekistan" },
        { code: "VU", name: "Vanuatu" },
        { code: "VE", name: "Venezuela, Bolivarian Republic of" },
        { code: "VN", name: "Viet Nam" },
        { code: "VG", name: "Virgin Islands, British" },
        { code: "VI", name: "Virgin Islands, U.S." },
        { code: "WF", name: "Wallis and Futuna" },
        { code: "EH", name: "Western Sahara" },
        { code: "YE", name: "Yemen" },
        { code: "ZM", name: "Zambia" },
        { code: "ZW", name: "Zimbabwe" }
      ];

    useEffect(() => {
        const loadData = async () => {
            try {
                if (!encoded) {
                    navigate('/pricing-plans');
                    return;
                }

                const decompressedData = decompressFromEncodedURIComponent(encoded);
                if (!decompressedData) {
                    navigate('/pricing-plans');
                    return;
                }

                const parsedData = JSON.parse(decompressedData);
                console.log("subscription data", parsedData)
                setSubscriptionData(parsedData);

            } catch (error) {
                console.error('Error parsing subscription data:', error);
                navigate('/pricing-plans');
            } finally {
                setLoading(false);
            }
        };

        loadData();
    }, [encoded, navigate]);

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);

        if (!stripe || !elements) {
            console.error("Stripe.js hasn't loaded yet.");
            setLoading(false);
            return;
        }

        const card = elements.getElement(CardElement);

        if (!card) {
            showToast("error", "Payment Error", "Card input not available. Please refresh the page.");
            setLoading(false);
            return;
        }

        try {
            const { error, paymentMethod } = await stripe.createPaymentMethod({
                type: "card",
                card,
            });

            if (error) {
                console.error("Payment method error:", error.message);
                showToast("error", "Payment Failed", error.message);
                setLoading(false);
                return;
            }

            // Build your payload
            const formData = {
                priceId: subscriptionData.plan,
                paymentMethodId: paymentMethod.id,
                outboundEnabled: subscriptionData.outboundEnabled,
                ...(subscriptionData.outboundEnabled && { autoTopUp: subscriptionData.autoRecharge }),
                phoneNumber: subscriptionData.selectedNumber,
                phonePriceId: subscriptionData.phonePriceId,
                ...(subscriptionData.outboundEnabled && { topUpAmount: Number(subscriptionData.topupAmount) }),
                isoCountry: subscriptionData.phoneNumberCountry,
                planName: subscriptionData.planName,
                freeMinutesIncluded: Number(subscriptionData.freeMinutesIncluded),
                overChargePerMin: Number(subscriptionData.overChargePerMin),
                card: paymentMethod.card.last4,
            };

            const data = await paymentProcess(formData);
            
            if (data.data?.success) {
                updateTrialInfo({ isTrial: false, daysRemaining: 0, trialEndDate: null })
                setIsActiveSubscription(true)
                navigate("/thankyou");
            } else {
                console.log(data)
                showToast("error", "Request Failed", data.data?.message || data.message || data.response.data.message);
            }
        } catch (err) {
            console.error("Unexpected error:", err);
            showToast("error", "Payment Failed", err.response.data.message || "An unexpected error occurred");
        } finally {
            setLoading(false);
        }
    };

    const calculateTotal = () => {
        const planPrice = Number(subscriptionData.planPrice?.replace('$', '') || 0);
        const phoneAmount = Number(subscriptionData.phoneNumberAmount || 0);
        const topupAmount = subscriptionData.outboundEnabled && subscriptionData.topupAmount
            ? Number(subscriptionData.topupAmount || 0)
            : 0;

        const totalAmount = planPrice + phoneAmount + topupAmount;
        return totalAmount;
    };

    return (
        <>
            {
                loading && (
                    <GlobalLoader isLoading={loading} />
                )
            }
            <Row className="checkout-container">
                {/* Left Panel: Summary */}
                <Col md={6} className="checkout-summary-container align-right">
                    <div className="checkout-summary">
                        <div className="summary-header">
                            <Link to={"/pricing-plans"} className="back-button cursor-pointer text-dark"><i className="ri-arrow-left-line"></i></Link>
                            <span className="logo-text d-flex align-items-center gap-1"><img src={CheckoutIcon} alt="icon" /> <span>WiseRep</span></span>
                        </div>

                        <div className="price-info">
                            <p className="label">Subscription fee</p>
                            <h1 className="amount">{subscriptionData?.planPrice && subscriptionData.planPrice} <span className="fs-14 fw-500 text-muted">Per month</span></h1>

                        </div>

                        <div className="summary-line mt-5">
                            <div>
                                <p className="m-0 text-dark fs-16">{subscriptionData?.planName && subscriptionData.planName}</p>
                                <span className="text-muted fs-16">Billed Monthly</span>
                            </div>
                            <span className="text-dark fw-600 fs-15">{subscriptionData?.planPrice && subscriptionData.planPrice}</span>
                        </div>
                        <div className="summary-line mt-3">
                            <div>
                                <p className="m-0 text-dark fs-16">Phone Number ({subscriptionData?.selectedNumber && subscriptionData.selectedNumber})</p>
                                <span className="text-muted fs-16">Billed Monthly</span>
                            </div>
                            <span className="text-dark fw-600 fs-15">${subscriptionData?.phoneNumberAmount && Number(subscriptionData.phoneNumberAmount).toFixed(2)}</span>
                        </div>
                        <div className="summary-line mt-3">
                            <div>
                                <p className="m-0 text-dark fs-16">Topup Amount</p>
                                <span className="text-muted fs-16">{subscriptionData && subscriptionData.autoRecharge ? "Billed Monthly" : "One Time"}</span>
                            </div>
                            <span className="text-dark fw-600 fs-15">${subscriptionData?.topupAmount && Number(subscriptionData.topupAmount).toFixed(2)}</span>
                        </div>

                        <span className="price-separator"></span>

                        <div className="summary-line">
                            <span className="m-0 text-dark fs-16">Subtotal</span>
                            <span className="text-dark fw-600 fs-15">${subscriptionData && calculateTotal()}</span>
                        </div>
                        <div className="summary-line">
                            <span className="m-0 text-dark fs-16">Tax</span>
                            <span className="text-muted fs-16">$0.00</span>
                        </div>

                        <span className="price-separator"></span>

                        <div className="summary-total">
                            <span className="m-0 text-dark fs-16">Total due today</span>
                            <span className="text-dark fw-600 fs-15">${subscriptionData && calculateTotal()}</span>
                        </div>
                    </div>
                </Col>

                {/* Right Panel: Payment Form */}
                <Col md={6} className="bg-white">
                    <form className="checkout-form" onSubmit={handleSubmit} id="checkoutForm">
                        <h5 className="fs-16 fw-500 mb-3">Contact Information</h5>
                        <div className="contact-info-container mb-4">
                            <p className="m-0">Email</p>
                            <p className="m-0">{details.userEmail}</p>
                        </div>
                        <h5 className="fs-16 fw-500 mb-3">Payment Method</h5>
                        <div className="form-group">
                            <label>Card information</label>
                            <CardElement className="card-element" />
                        </div>
                        {/* <div className="form-group">
                            <label>Card information</label>
                            <CardInput />
                        </div> */}

                        <div className="form-group">
                            <label>Cardholder name</label>
                            <input type="text" placeholder="Full name on card" className="rounded" value={details.cardName} onChange={(e) => setDetails((prev) => { return { ...prev, cardName: e.target.value } })} />
                        </div>

                        <div className="form-group">
                            <label>Country or region</label>
                            <select className="checkout-country">
                                <option>Choose Country</option>
                                {
                                    countries.map((country) => {
                                        return (
                                            <option key={country.code} value={country.code}>{country.name}</option>
                                        )
                                    })
                                }
                            </select>
                            <input className="checkout-address1" type="text" placeholder="Address line 1" value={details.address1} onChange={(e) => setDetails((prev) => { return { ...prev, address1: e.target.value } })} />
                            <input className="checkout-address2" type="text" placeholder="Address line 2" value={details.address2} onChange={(e) => setDetails((prev) => { return { ...prev, address2: e.target.value } })} />
                            <input className="checkout-suburb" type="text" placeholder="Suburb" value={details.suburb} onChange={(e) => setDetails((prev) => { return { ...prev, suburb: e.target.value } })} />
                            <Row>
                                <Col md={6} className="me-0 pe-0">
                                    <input className="checkout-city" type="text" placeholder="City" value={details.city} onChange={(e) => setDetails((prev) => { return { ...prev, city: e.target.value } })} />
                                </Col>
                                <Col md={6} className="ms-0 ps-0">
                                    <input className="checkout-postal" type="text" placeholder="Postal code" value={details.postalCode} onChange={(e) => setDetails((prev) => { return { ...prev, postalCode: e.target.value } })} />
                                </Col>
                            </Row>
                            <input className="checkout-state" type="text" placeholder="State" value={details.state} onChange={(e) => setDetails((prev) => { return { ...prev, state: e.target.value } })} />
                        </div>

                        <button type="submit" className="subscribe-button">Subscribe</button>
                    </form>
                </Col>
            </Row>
        </>
    );
}

export default CheckoutPage
